import { render, staticRenderFns } from "./RelationDetails.vue?vue&type=template&id=dde2df16&scoped=true"
import script from "./RelationDetails.vue?vue&type=script&lang=ts"
export * from "./RelationDetails.vue?vue&type=script&lang=ts"
import style0 from "./RelationDetails.vue?vue&type=style&index=0&id=dde2df16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde2df16",
  null
  
)

export default component.exports